import { ProductWithAttributes, Product } from './product'
import { VendorName } from './models/vendor'

export const isIneProduct = (product: ProductWithAttributes | Product) => {
    return product.vendorName === VendorName.Oslo
}
